import { render, staticRenderFns } from "./HolidaysPage.vue?vue&type=template&id=351f7084&scoped=true&"
import script from "./HolidaysPage.vue?vue&type=script&lang=js&"
export * from "./HolidaysPage.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysPage.vue?vue&type=style&index=0&id=351f7084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f7084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351f7084')) {
      api.createRecord('351f7084', component.options)
    } else {
      api.reload('351f7084', component.options)
    }
    module.hot.accept("./HolidaysPage.vue?vue&type=template&id=351f7084&scoped=true&", function () {
      api.rerender('351f7084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HolidaysPage.vue"
export default component.exports